import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { Context } from "../../../index";
import { RoutesList } from "../../../routes";

import { useTranslation } from "react-i18next";

const PostItem = ({ post }) => {
 const { t } = useTranslation();
 const { storeblog } = useContext(Context);

 const [category, setCategory] = useState("Finanzas");

 useEffect(() => {
  const categoriesNames = [`${t("Finance")}`, `${t("Health")}`, `${t("Inne")}`];
  post.category === "FINANCE"
   ? setCategory(categoriesNames[0])
   : post.category === "HEALTH"
   ? setCategory(categoriesNames[1])
   : post.category === "ANOTHER"
   ? setCategory(categoriesNames[2])
   : setCategory(categoriesNames[2]);
 }, [post.category]);
 const handleClick = () => {
  storeblog.setSelectedCategory("");
  window.scrollTo({
   top: 0,
   behavior: "smooth", // для плавного скролу
  });
 };

 return (
  <>
   <Link
    to={RoutesList.POST_ROUTER + "/" + post.seoName + "/" + post._id}
    onClick={handleClick}
    className="col cursor-pointer"
   >
    <div className="col">
     <button type="button" className="populer-sec1-news ">
      <figure>
       <img src={post.mainImg} alt="" />
       <span className="st-tags"> {category}</span>
       {post.isTop ? (
        <div className="content_isTop">
         <span>{t("Exclusive")}</span>
        </div>
       ) : null}
      </figure>
      <div className="content-div1">
       <h5> {post.title} </h5>
      </div>
     </button>
    </div>
   </Link>
  </>
 );
};

export default observer(PostItem);
